import React, {useCallback, useRef, useState} from 'react';
import type {DataFormPartRenderer} from 'schema/types';
import type {PartText} from 'schemaDefinition/types';
import {useLocalization} from 'localization';
import {CheckboxField, FlexBox, Spacer} from 'components';
import {DataFormSingleValue} from 'schema/form/components/DataFormSingleValue';
import {useDataFormContext} from 'schema/form/contexts';

export const EditPartCity: DataFormPartRenderer = props => {
  const {id, setEditValue} = useDataFormContext();
  const {part, valuePath, useValue, ...rest} = props;
  const placePart = part as PartText;
  const value = useValue(valuePath, id);
  const {t} = useLocalization();
  const placeNotIdientified = t('form.global.field.placeNotIdentified.label');
  const firstValue = useRef(value?.toString());

  const [isEmpty, setIsEmpty] = useState<boolean>(
    value === placeNotIdientified,
  );

  const handleCheckboxChange = useCallback(
    (v: boolean) => {
      setIsEmpty(v);
      if (v) {
        setEditValue(valuePath, placeNotIdientified, placePart);
      } else {
        setEditValue(valuePath, firstValue.current ?? '', placePart);
      }
    },
    [placeNotIdientified, placePart, setEditValue, valuePath],
  );

  return (
    <FlexBox horizontal>
      <DataFormSingleValue
        part={placePart}
        useValue={useValue}
        valuePath={valuePath}
        {...rest}
        mode={isEmpty ? 'read-only' : 'edit'}
      />
      <Spacer size={2} />
      <CheckboxField
        fieldId={'setEmpty'}
        name={'setEmpty'}
        value={isEmpty}
        label={placeNotIdientified}
        onChange={handleCheckboxChange}
      />
    </FlexBox>
  );
};
